/**
 * @desc bom外发列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlmBomOutgoingListResponseDto>
>;
export function request(
  body: defs.basics.PlmBomOutgoingRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/outgoing`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
